import React from 'react';
import './ServicesHeroSection.css';

export default function ServicesHeroSection({ headline, subheading, ctaPrimary, ctaSecondary, backgroundImage }) {
  return (
    <section
      className="hero1-section"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="hero1-content">
        <h1 className="hero1-headline">{headline}</h1>
        <p className="hero1-subheading">{subheading}</p>
        <div className="hero1-buttons">
          <a href={ctaPrimary.link} className="btn btn-primary">
            {ctaPrimary.text}
          </a>
          {ctaSecondary && (
            <a href={ctaSecondary.link} className="btn btn-secondary">
              {ctaSecondary.text}
            </a>
          )}
        </div>
      </div>
    </section>
  );
}
